import store from '@polleverywhere/redux'
import { slice as appSlice } from '../../slices/app'
import { slice as profileSlice } from '@polleverywhere/redux/slices/profile'
import { html } from 'lit-html'

export default async function signup (state, appOptions) {
  const reduxState = store.getState()

  // If we're already logged in, go back or default
  if (profileSlice.selectIsLoggedIn(reduxState)) {
    store.dispatch(appSlice.pageUpdatedToDefault())
    return
  }

  // Gate check
  if (!reduxState[appSlice.name].options.allowSignups) {
    store.dispatch(appSlice.pageUpdatedToDefault())
    return
  }

  await import(/* webpackChunkName: 'signup' */ '../../components/signup')

  return html`<pec-signup-page></pec-signup-page>`
}
